var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndowmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5, 4.5) scale(0.7)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36 6h-24a1 1 0 0 0 -1 1v34a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-34a1 1 0 0 0 -1-1zm-17 34v-18.7187a6.9852 6.9852 0 0 1 3.1172-5.8243l1.8828-1.2553 1.8828 1.2553a6.9852 6.9852 0 0 1 3.1172 5.8243v18.7187zm16 0h-4v-18.7187a8.9819 8.9819 0 0 0 -4.0078-7.4883l-2.4375-1.625a1.0009 1.0009 0 0 0 -1.1094 0l-2.4375 1.625a8.9819 8.9819 0 0 0 -4.0078 7.4883v18.7187h-4v-32h22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndowmentIcon);
export default __webpack_public_path__ + "static/media/endowment-icon.8609e3b4a5b8c905c46071cf1e02b83c.svg";
export { ForwardRef as ReactComponent };